import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ProjectCard title="Data Science Internship" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`Internship project on the domain of Natural Language Processing and Information Retrieval.`}</p>
      <p>{`Applied Dimension Reduction, Clustering and Topic Modelling on news articles.`}</p>
    </ProjectCard>
    <ProjectCard title="Scraping news articles from news sites" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`Web scraping project of scraping news articles using Scrapy framework. `}</p>
      <p>{`Used Scrapy pipelines, middlewares and items to make unique checking of scraped fields and storing to Mongodb.
I am also making a Python package for the same.
Used Scrapyd and ScrapydWeb for deployment and scheduling the spiders for automation of scraping on regular basis.`}</p>
    </ProjectCard>
    <ProjectCard title="Early Alzheimer detection" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`Work in progress`}</p>
    </ProjectCard>
    <ProjectCard title="Identity Management and Authentication system using Blockchain(Ongoing)" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
Under the guidance of - Dr. Kousik Dasgupta(Faculty CSE KGEC) 
      <p>{`Web developer and designer of the team.
Developed the front end using HTML ,CSS, Bootstrap of the Hyperledger Sawtooth smart contract.
The Rest API is built using Flask. `}</p>
    </ProjectCard>
    <ProjectCard title="KWOC 2019 project on the topic of Hotel management app using Django" link="https://github.com/Suchana34/nest4guest" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`Kharagpur Winter of Code is a 5-week long online program for students organised by Kharagpur Open Source Society, IIT KGP.
Worked on the django project of hotel management app, solved issues and multiple pull requests merged.`}</p>
    </ProjectCard>
    <ProjectCard title="Case studies on Ethereum smart contracts" link="https://github.com/Suchana34/case_studies_of_blockchain" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`Made a repository consisting of collection of various smart contract codes using solidity language on various topics like document verification, Smart switch for IOT devices, cryptocurrency, etc. `}</p>
    </ProjectCard>
    <ProjectCard title="Check Repositories - My hands on with Github API" link="http://suchana.cf/Check_Repos/" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`It uses gitub api to display all the repository details of a github user when the github handle of the person is specified. `}</p>
    </ProjectCard>
    <ProjectCard title="Open Source Contributor in GirlScript Summer Of Code 2020 (gssoc 2020)" link="https://github.com/Suchana34/footsteps-app" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`Selected for GirlScript Summer of Code and worked on the project of  `}<a parentName="p" {...{
          "href": "https://github.com/fnplus/footsteps-app"
        }}>{`https://github.com/fnplus/footsteps-app`}</a>{`  which is a React project using Gatsby and pull requests merged. `}</p>
    </ProjectCard>
    <ProjectCard title="Multiple web dev projects at Hacktoberfest 2019 - presented by DigitalOcean and DEV" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
    </ProjectCard>
    <ProjectCard title="Animal Kingdom Dapp" link="https://xenodochial-booth-b5ef9e.netlify.com/" bg="linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)" mdxType="ProjectCard">
      <p>{`I followed the tutorials on blockstack.js and made a Dapp using blockstack.js and React.`}</p>
      <p>{`The Dapp is hoted by App.co. Static site hosted on Netlify.`}</p>
    </ProjectCard>
    <h2>{`Blogs`}</h2>
    <ProjectCard title="Sharing my experience of Kharagpur Winter Of Code 2019" link="https://medium.com/@suchanachakraborty/kwoc-kharagpur-winter-of-code-an-end-evaluation-report-of-my- experience-a5ce7271eb50" bg="linear-gradient(to right, #667eea 0%, #764ba2 100%)" mdxType="ProjectCard">
      <p>{`Start Reading now and give some thumbs up!!`}</p>
    </ProjectCard>
    <ProjectCard title="Probability Distributions and Hypothesis Tests using Python." link="https://medium.com/analytics-vidhya/probability-distributions-and-hypothesis-tests-using-python-2ee25cb3a90f" bg="linear-gradient(to right, #667eea 0%, #764ba2 100%)" mdxType="ProjectCard">
      <p>{`Start Reading now and give some thumbs up!!`}</p>
      <p>{`This article is published in Analytics Vidhya and made my way to their technical writers group.`}</p>
    </ProjectCard>
    <ProjectCard title="Analysis of Ethereum Blockchain for beginners" link="https://medium.com/@suchanachakraborty/analysis-of-ethereum-blockchain-for-beginners-acd53efa37fd" bg="linear-gradient(to right, #667eea 0%, #764ba2 100%)" mdxType="ProjectCard">
      <p>{`Start Reading now and give some thumbs up!!`}</p>
      <p>{`This article is published in Cryptocurrency Hub and made my way to their technical writers group.`}</p>
    </ProjectCard>
    <ProjectCard title="Making Web Crawler and Scraper: The Easy Way" link="https://medium.com/@suchanachakraborty/making-web-crawler-and-scraper-the-easy-way-1a5f93fcb462" bg="linear-gradient(to right, #667eea 0%, #764ba2 100%)" mdxType="ProjectCard">
      <p>{`Start Reading now and give some thumbs up!!`}</p>
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      